<template>
  <div>
    <div id="object-help" class="object-action" v-on:click="displayModal($event)">
      <a data-gtm-id="get-help-in-person" href class="btn btn-light">Learning Tips</a>
    </div>
    <modal v-if="showModal" @close="showModal = false"></modal>
  </div>
</template>

<script>
  import modal from './components/_object-help-in-person-modal.vue';

  export default {
    components: {
      'modal' : modal,
    },
    data() {
      return {
        showModal : false
      }
    },
    methods: {
      displayModal(e){
        e.preventDefault();
        this.showModal = true;
      }
    }
  }
</script>
